"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerRoundEvents = exports.Modifiers = void 0;
var Modifiers;
(function (Modifiers) {
    Modifiers["FATIGUE"] = "FATIGUE";
})(Modifiers || (exports.Modifiers = Modifiers = {}));
/**
 * Defines the distinct types of events that can happen to a player during a round.
 * This is an enum to ensure it can be accessed as a value at runtime.
 */
var PlayerRoundEvents;
(function (PlayerRoundEvents) {
    PlayerRoundEvents["DISCARDED"] = "DISCARDED";
    PlayerRoundEvents["UNDEAD"] = "UNDEAD";
    PlayerRoundEvents["STAMINA_LOSS"] = "STAMINA_LOSS";
    PlayerRoundEvents["SOUL_SAP_1"] = "SOUL_SAP_1";
    PlayerRoundEvents["SOUL_SAP_2"] = "SOUL_SAP_2";
    PlayerRoundEvents["RECOVERED"] = "RECOVERED";
    PlayerRoundEvents["GOAL_MACHINE"] = "GOAL_MACHINE";
    PlayerRoundEvents["GOALIE_STAMINA_LOSS"] = "GOALIE_STAMINA_LOSS";
    PlayerRoundEvents["IGNITE"] = "IGNITE";
    PlayerRoundEvents["INSPIRE"] = "INSPIRE";
})(PlayerRoundEvents || (exports.PlayerRoundEvents = PlayerRoundEvents = {}));
